<template>
    <div class="list--view responsive-element">
        <div data-toggle="tooltip" data-placement="top" title="Filtra per tipologia" class="single--list-view single--list-view-roles">
            <vs-select class="selectExample" v-model="selectTypeRoles" @input="typologySelected">
                <vs-select-item :is-selected="item.isSelected" :key="index" :value="item.value" :text="item.label"
                    v-for="(item, index) in optionsTypeRoles" />
            </vs-select>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            selectTypeRoles: /typology=([^&]+)/.exec(location.href) == null ? "" : /typology=([^&]+)/.exec(location.href)[1],
            optionsTypeRoles: [],
        }
    },
    methods: {
        typologySelected(selectedOption, id) {

            if (selectedOption === '') {
                location.href = "/family-members";
            }
            else {
                location.href = app.__vue__.addParam('typology', selectedOption);
            }
        },
        loadTypologies() {
            axios
                .get("/getFamilyMembersTypology")
                .then(response => {
                    //this.datas = response.data;
                    this.optionsTypeRoles = response.data;
                });
        },
    },
    mounted() {
        this.loadTypologies();
    }
}
</script>
